import React from 'react';
export function SocialProof() {
  return <section className="py-4 px-5 bg-[#000000]" data-id="element-255">
      <div className="max-w-xl mx-auto" data-id="element-256">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center" data-id="element-257">
          <StatItem value="+2,000" label="PERSONAS YA LO USAN" data-id="element-258" />
          <StatItem value="6" label="TOMOS COMPLETOS" data-id="element-259" />
          <StatItem value="4.9/5" label="CALIFICACIÓN ⭐" data-id="element-260" />
          <StatItem value="🌎" label="LATINOAMÉRICA" isEmoji data-id="element-261" />
        </div>

        {/* Info badges */}
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mt-5 pt-4 border-t border-slate-800/50" data-id="element-262">
          <span className="text-xs md:text-sm text-slate-400 font-medium" data-id="element-263">
            📄 100% digital (PDF)
          </span>
          <span className="text-xs md:text-sm text-slate-400 font-medium" data-id="element-264">
            ⚡ Acceso inmediato
          </span>
          <span className="text-xs md:text-sm text-slate-400 font-medium" data-id="element-265">
            🧠 Para adultos que quieren sanar la relación con tus padres
          </span>
        </div>
      </div>
    </section>;
}
function StatItem({
  value,
  label,
  isEmoji
}: {
  value: string;
  label: string;
  isEmoji?: boolean;
}) {
  return <div className="flex flex-col items-center justify-center py-2" data-id="element-266">
      <div className={`${`${isEmoji ? 'text-3xl' : 'text-2xl md:text-3xl'} font-black text-brand-yellow mb-1`} text-[#FBBE24]`} data-id="element-267">
        {value}
      </div>
      <div className="text-[10px] md:text-xs text-slate-500 font-semibold uppercase tracking-wider leading-tight" data-id="element-268">
        {label}
      </div>
    </div>;
}